import { endpoints } from '../../Constants';
import { authHeader, toQueryStringURL } from '../../Helpers';
import handleResponse from '../helpers';

const qualitySettingServices = {
	gateway,
};

function gateway({ req, method }) {
	switch (method) {
		case 'VIEW':
			return viewSettings({
				req,
			});
		case 'PATCH':
			return toggle({
				req,
			});
		default:
			break;
	}
	return new Promise();
}

function viewSettings({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.QUALITY_SETTING, params);

	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function toggle({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.QUALITY_SETTING, params);

	const requestOptions = {
		method: 'PATCH',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(url, requestOptions).then(handleResponse);
}
export default qualitySettingServices;
